import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getBaseURL } from '@/utils/request'

/** 视频播放地址（暂不使用流播放，直接使用接口 videoUrl） */
export function getVideoPlayUrl (item) {
  return (item && item.videoUrl) || ''
}

/** 标准视频流式播放地址（video 标签 src，携带鉴权） */
export function getAiStandardVideoStreamUrl (id) {
  const token = storage.get(ACCESS_TOKEN) || sessionStorage.getItem(ACCESS_TOKEN)
  const base = `${getBaseURL()}/ai-meeting/sys/AiStandardVideo/Stream/play/${id}`
  if (!token) return base
  const sep = base.includes('?') ? '&' : '?'
  return `${base}${sep}Authorization=${encodeURIComponent(token)}`
}

export function normalizeListData (data) {
  if (Array.isArray(data)) return data
  if (data && Array.isArray(data.records)) return data.records
  if (data && Array.isArray(data.list)) return data.list
  return []
}
